import axios from "axios";
import { url } from "./utils/url";
import authHeader from "./utils/auth-header";

class DirectoryApi {
  static async getAll() {
    const result = await axios.get(`${url}/admin/directories`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async getOne(id: any) {
    const result = await axios.get(`${url}/admin/directories/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async getOneBoth(id: any) {
    const result = await axios.get(`${url}/admin/directories/${id}/both`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async delete(id: any) {
    const result = await axios.delete(`${url}/admin/directories/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async create(body: any) {
    const result = await axios.post(`${url}/admin/directories`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async update(id: any, body: any) {
    const result = await axios.put(`${url}/admin/directories/${id}`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async upload(body: any) {
    const result = await axios.post(
      `${url}/admin/directories/photo/upload`,
      body,
      {
        headers: authHeader(),
      }
    );

    return result.data;
  }

  static async deleteImage(id: any) {
    const result = await axios.delete(`${url}/admin/directories/image/${id}`, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async deleteImageSource(body: any) {
    const result = await axios.post(
      `${url}/admin/directories/imageSource`,
      body,
      {
        headers: authHeader(),
      }
    );

    return result.data;
  }
}

export default DirectoryApi;
